import { action, makeObservable, observable } from 'mobx';

class StoreStore {
    constructor() {
        makeObservable(this)
    }

    // Stores
    @observable stores = {}
    @action setStores(stores: any) {
        this.stores = stores;
    }

    @action addStore(storeId: number, storeData: any) {
        this.stores[storeId] = storeData;
    }

    @action updateStore(storeId: number, storeData: any) {
        this.stores[storeId] = storeData;
    }

    @action deleteStore(storeId: number) {
        delete this.stores[storeId];
    }
    // Stores
}

const store = new StoreStore();

export default store;